import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('packageItemValue', packageItemValue);

function packageItemValue(splitService) {
  return function packageSpotsFilter(item, enableUnitDisplay) {
    const currencyCode = splitService.getCurrencyCode();
    const isPackageTotalValue = splitService.isOmsPackageTotalValue();

    const itemValue = (isPackageTotalValue ? item.value : (item.value * (item.count || 1)))
    const displayValue = itemValue.toLocaleString(undefined, {maximumFractionDigits: 2})
    return `${displayValue} ${enableUnitDisplay ? currencyCode : ''}`;
  }
}
